// extracted by mini-css-extract-plugin
module.exports = {"menu":"LeftMenu_menu__1lBLu","menuItems":"LeftMenu_menuItems__25fvU","login":"LeftMenu_login__HaK8Z"};